export function save(storageName, fullStorage) {
    return localStorage.setItem(storageName, JSON.stringify(fullStorage));
}

export function clear(storageName) {
    return localStorage.setItem(storageName, JSON.stringify({}));
}

export function getAllValues(storageName) {
    if (! localStorage.getItem(storageName)) {
        localStorage.setItem(storageName, JSON.stringify({}));
    }

    return JSON.parse(localStorage.getItem(storageName));
}

export function storageIsExist(storageName) {
    if (! localStorage.getItem(storageName)) {
        return false;
    }

    return true;
}